<template>
  <section class="claims-tab">
    <h3>Claims</h3>
    <section v-if="!isManual">
      <div
        v-for="(claimItem, claimIndex) in claimsList"
        :key="claimIndex"
        class="flex-sb">
        <div class="left">
          <span>Policy Period</span>
          <span class="date">{{ claimItem.period }}</span>
        </div>
        <div class="container flex-1">
          <div
            v-for="(item, index) in claimItem.record"
            :key="index"
            class="card">
            <div class="header flex-sb">
              <div>
                <span class="title">Claim Ticket</span>
                <span
                  class="id"
                  @click="handlerToTicketDetail(item.ticket_id)">#{{ item.ticket_id }}</span>
              </div>
              <div>
                <v-button
                  type="primary"
                  @click="handlerEditClaim(claimIndex, index)">Edit</v-button>
              </div>
            </div>
            <div
              v-for="(logItem, logIndex) in item.log"
              :key="logIndex"
              class="content">
              <div>
                <span class="time">{{ logItem.created_at }}</span>
                <span>{{ logItem.assignee }}</span>
              </div>
              <p>{{ logItem.content }}</p>
              <file-container
                v-for="(file, fIndex) in logItem.other_file"
                :key="fIndex"
                :fileData="file" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
      v-else
      class="container flex-1">
      <div
        v-for="(claimItem, claimIndex) in claimsList"
        :key="claimIndex"
        class="flex-sb">
        <div class="container flex-1">
          <div
            v-for="(item, index) in claimItem.record"
            :key="index"
            class="card">
            <div class="header flex-sb">
              <div>
                <span class="title">Claim Ticket</span>
                <span
                  class="id"
                  @click="handlerToTicketDetail(item.ticket_id)">#{{ item.ticket_id }}</span>
              </div>
              <div>
                <v-button
                  type="primary"
                  @click="onHandlerEditClaim(claimIndex, index)">Edit</v-button>
              </div>
            </div>
            <div
              v-for="(logItem, logIndex) in item.log"
              :key="logIndex"
              class="content">
              <div>
                <span class="time">{{ logItem.created_at }}</span>
                <span>{{ logItem.assignee }}</span>
              </div>
              <p>{{ logItem.content }}</p>
              <file-container
                v-for="(file, fIndex) in logItem.other_file"
                :key="fIndex"
                :fileData="file" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <span
      v-if="claimsList.length < 1"
      class="no-data">No Data</span>

    <claim-detail-dialog
      ref="claim-detail-dialog"
      :form="claimEditData"
      @save="handlerUpdateClaim" />

    

  </section>
</template>
<script>
import FileContainer from '@/views/components/file-container'
import ClaimDetailDialog from './dialog/claim-detail-dialog'
export default {
  name: 'ClaimsTab',
  components: {
    FileContainer,
    ClaimDetailDialog
  },
  props: {
    claims: {
      type: Array,
      default: () => ([])
    },
    isManual: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      claimsList: [],
      claimDialog: false,
      claimEditData: {},
      claimIndex: -1,
      recordIndex: -1,
    }
  },
  computed: {
    isEmptyClaim() {
      if(!this.isManual) return false
      
      let result = true
      this.claims.some(item => {
        const record = item.record || []
        if(record && record.length > 0) {
          result = false
          return true
        }
        if(!result) return true
      })
      return result
    }
  },
  watch: {
    claims: {
      deep: true,
      immediate: true,
      handler(val) {
        // 過濾一下 ?
        if(this.isEmptyClaim) {
          this.claimsList = [
            {
              record: [
                {

                }
              ]
            }
          ]
        }
        else {
          this.claimsList = JSON.parse(JSON.stringify(val))
        }
      }
    },
  },
  methods: {
    onHandlerEditClaim(claimIndex, index) {
      if(this.isEmptyClaim) {
        this.$emit('add-claim')
      }
      else {
        this.handlerEditClaim(claimIndex, index)
      }
    },
    handlerEditClaim(claimIndex, index) {
      this.claimIndex = claimIndex
      this.recordIndex = index
      this.claimEditData = this.claimsList[claimIndex].record[index]
      // this.claimDialog = true
      this.$refs['claim-detail-dialog'].changeDialog()
    },
    handlerUpdateClaim(data) {
      this.$set(this.claimsList[this.claimIndex].record, this.recordIndex, data)
    },
    //点击跳转到all suport ticket claim 索偿详情
    handlerToTicketDetail(ticketId){
      if(!ticketId) return

      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: ticketId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.claims-tab {
  white-space:pre-wrap;
    .flex-sb {
        padding-top: 10px;
        .left {
            width: 200px;
            span {
                color: #91939A;
                font-size: 16px;
            }
            .date {
                display: block;
                color: #616266;
                font-weight: 500;
            }
        }
        .container {
            .card {
                .header {
                    align-items: center;
                    padding-top: 0;
                    padding-bottom: 10px;
                    font-size: 16px;
                    .title {  
                        color: #616266;
                        font-weight: 500;
                        font-size: 16px;
                    }
                    .id {
                        padding-left: 10px;
                        color: #409EFF;
                        cursor: pointer;
                    }
                }
                .content {
                    margin: 0 -15px;
                    padding: 15px;
                    border-top: 1px solid #dddfe7;
                    .time {
                        font-size: 14px;
                        font-weight: 500;
                        & + span {
                            padding-left: 10px;
                            color: #91939a;
                        }
                    }
                    p {
                        padding: 10px 0;
                        font-size: 14px;
                        line-height: 16px;
                        color: #616266;
                    }
                }
            }
        }
    }
}
</style>